import VueRouter from 'vue-router'
import Home from '../pages/Home'
import Contacts from '../pages/Contacts'
import About from '../pages/About'
import Gallery from '../pages/Gallery'
import Category from '../pages/Category'
import Article from '../pages/Article'
import AdminLogin from '../admin/pages/AdminLogin'
import AdminConfigSite from '../admin/pages/AdminConfigSite'
import AdminArticles from '../admin/pages/articles/AdminArticles'
import AdminArticleNew from '../admin/pages/articles/AdminArticleNew'
import AdminArticleEdit from '../admin/pages/articles/AdminArticleEdit'
import AdminComments from '../admin/pages/comments/AdminComments'
import AdminCommentEdit from '../admin/pages/comments/AdminCommentEdit'
import AdminCommentNew from '../admin/pages/comments/AdminCommentNew'
import AdminGallery from '../admin/pages/AdminGallery'
import AdminMenu from '../admin/pages/AdminMenu'
import AdminBanners from '../admin/pages/AdminBanners'
import AdminCategories from '../admin/pages/categories/AdminCategories'
import AdminCategoryEdit from '../admin/pages/categories/AdminCategoryEdit'
import AdminCategoryNew from '../admin/pages/categories/AdminCategoryNew'

//const Contacts = () => import('../pages/Contacts')
// function lazyLoad(path){    
//     const com = () => import('../pages/Contacts.vue')
//     console.log("component: ", com)
//     return com
//   }

 let router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {                
                layout: 'default'
            }
        },
        {
            path: '/#*',
            name: 'home',
            component: Home,
            meta: {                
                layout: 'default'
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contacts,
            meta: {                
                layout: 'default'
            }
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: {                
                layout: 'default'
            }
        },
        {
            path: '/gallery',
            name: 'gallery',
            component: Gallery,
            meta: {                
                layout: 'default'
            }
        },

        {
            path: '/category/:category_id',
            name: 'category',
            component: Category,
            meta: {
                layout: 'default'
            }
        },
        {
            path: '/category',
            name: 'categories',
            component: Category,
            meta: {
                layout: 'default'
            }
        },

        {
            path: '/article/:article_id',
            name: 'article',
            component: Article,
            meta: {
                layout: 'default'
            }
        },
        
        {
            path: '/admin_login',
            name: 'admin_login',
            component: AdminLogin,
            meta: {                
                layout: 'default'
            }           
        },
        {
            path: '/admin_config',
            name: 'admin_config',
            component: AdminConfigSite,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        
        {
            path: '/admin_menu',
            name: 'admin_menu',
            component: AdminMenu,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_gallery',
            name: 'admin_gallery',
            component: AdminGallery,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        //comments
        {
            path: '/admin_comments',
            name: 'admin_comments',
            component: AdminComments,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_comment_new',
            name: 'admin_comment_new',
            component: AdminCommentNew,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_comment_edit',
            name: 'admin_comment_edit',
            component: AdminCommentEdit,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        //end comments
        {
            path: '/admin_banners',
            name: 'admin_banners',
            component: AdminBanners,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },        
        //articles
        {
            path: '/admin_articles',
            name: 'admin_articles',
            component: AdminArticles,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_article_edit',
            name: 'admin_article_edit',
            component: AdminArticleEdit,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_article_new',
            name: 'admin_article_new',
            component: AdminArticleNew,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        //articles end
        
        //categories
        {
            path: '/admin_categories',
            name: 'admin_categories',
            component: AdminCategories,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_category_edit/:category_id',
            name: 'admin_category_edit',
            component: AdminCategoryEdit,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        {
            path: '/admin_category_new',
            name: 'admin_category_new',
            component: AdminCategoryNew,
            meta: {
                requiresAuth: true,
                layout: 'admin'
            }
        },
        //categories end

        {
            path: '*',            
            redirect: '/'           
        }
    ], 
    mode: 'history'  
})

router.beforeEach((to, from, next) => {

    // console.log("routes to obj: ", to);
    // console.log("routes from obj: ", from);
    // console.log("routes to obj meta: ", to.meta.requiresAuth);
    //console.log("routes store obj: ", this.$store);
    //console.log("routes localStorage obj: ", localStorage.getItem('user'))
    
    let us = JSON.parse(localStorage.getItem('user'));
    if(to.meta.requiresAuth !== undefined){
        if(us !== null && us.login === 'admin'){
            console.log("user admin home");
            next({nextUrl: to.fullPath});
        }else{
            console.log("user admin login");
            next({name: 'admin_login'});
        }
        console.log("routes to obj meta: ", to.meta.requiresAuth);

    }else{
        next({nextUrl: to.fullPath});
    }

    window.scrollTo(0,0)
})

export default router;